
import Vue from "vue";
import ListDeletedFolders from "./ListDeletedFolders.vue";

export default Vue.extend({
  components: {
    ListDeletedFolders
  }
});
